<template>
    <ul class="navbar-nav navbar-nav-click align-items-lg-center ml-lg-auto">
        
        <base-dropdown tag="li" class="nav-item d-none d-lg-inline" menu-classes="dropdown-menu-xl dropdown-menu-right py-0">
            <a slot="title" href="#" v-on:click.prevent class="nav-link nav-link-icon" data-toggle="dropdown" role="button">
                <i class="ni ni-basket ni-2"></i>
                <i class="fa fa-caret-down ml-2"></i>
            </a>
            <card type="white"
                header-classes=""
                body-classes="p-0"
                class="border-0">
                <template v-slot:header>
                    <div>
                        <div class="d-inline float-left cart-dropdown-icon"><i class="ni ni-basket ni-2"></i><span class="badge badge-pill badge-default">{{sacolaTitulos.length}}</span></div>
                        <div class="d-inline float-right text-muted"><small>Sacola de Títulos</small></div>
                    </div>
                </template>
                <template>
                    <ul class="cart-items list-group list-group-flush" v-if="!sacolaTitulos.length">
                        <li class="list-group-item text-center">você não possui nenhum título na sacola</li>
                    </ul>
                    <ul class="cart-items list-group list-group-flush" v-if="sacolaTitulos.length">
                    <li class="list-group-item px-4" :class="[midia.preco ? 'gold' : '']" v-for="midia in sacolaTitulos.slice(0,5)" :key="midia.id"><strong>{{midia.titulo}}</strong> - <img width="20" height="20" :src="[midia.formato ? 'img/mediaformat/'+midia.formato+'.svg' : '']"><small>&nbsp;{{midia.formato}}</small><span class="badge badge-info ml-2">{{midia.origem}}</span><span class="badge badge-success" v-if="midia.audio">{{midia.audio}}</span><span class="badge badge-secondary" v-if="midia.temporada">{{midia.temporada}}&#170; temporada</span></li>
                    </ul>
                </template>
                <template v-slot:footer>
                    <div class="d-inline float-left">
                        <base-button type="default" icon="ni ni-basket" @click="$router.push('/sacola')">Ver Tudo</base-button>
                    </div>
                    <div class="d-inline float-right">
                        <base-button type="success" icon="ni ni-cart" @click="checkCartItemToCheckout()" :disabled="!sacolaTitulos.length">Finalizar</base-button>
                    </div>
                </template>
            </card>
        </base-dropdown>

        <base-dropdown tag="li" class="nav-item d-none d-lg-inline" v-if="isAuthenticated">
            <a slot="title" href="" v-on:click.prevent class="nav-link nav-link-icon" data-toggle="dropdown" role="button">
                <span class="nav-link-inner--text">{{userLogin}}</span>
                <i class="fa fa-caret-down ml-2 mr-2"></i>
            </a>
            <router-link to="/perfil" class="dropdown-item">
                <i class="ni ni-circle-08"></i>
                <span class="nav-link-inner--text">Perfil</span>
            </router-link>
            <router-link to="/perfil/enderecos" class="dropdown-item">
                <i class="fa fa-home"></i>
                <span class="nav-link-inner--text">Endereços</span>
            </router-link>
            <router-link to="/perfil/pedidos" class="dropdown-item">
                <i class="ni ni-app"></i>
                <span class="nav-link-inner--text">Pedidos</span>
            </router-link>
            <router-link to="/logout" class="dropdown-item">
                <i class="ni ni-button-power"></i>
                <span class="nav-link-inner--text">Sair</span>
            </router-link>
        </base-dropdown>
        
        <li class="nav-item ml-lg-4 d-none d-lg-inline" v-if="!isAuthenticated">
            <a @click="changeModalState" rel="noopener"
                class="btn btn-neutral btn-icon">
                <span class="btn-inner--icon">
                    <i class="fa fa-sign-in"></i>
                </span>
                <span class="nav-link-inner--text ml-2 d-lg-none d-xl-inline">Entrar</span>
            </a>
        </li>

        <SlideYUpTransition :duration="500">
            <div class="modal fade"
                 @click.self="changeModalState"
                 :class="[{'show d-block': showModal}, {'d-none': !showModal}]"
                 v-show="showModal"
                 tabindex="-1"
                 role="dialog"
                 :aria-hidden="!showModal">

              <div class="modal-dialog modal-dialog-centered modal-md">
                <div class="modal-content">
                  <div class="modal-body p-0">
                    <card type="secondary" shadow
                        header-classes="bg-white pb-5"
                        body-classes="px-lg-5 py-lg-5"
                        class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <small>Fazer login utilizando</small>
                            </div>
                        <auth-social-component></auth-social-component>
                        </template>
                        <template>
                            <div class="text-center text-muted mb-4">
                                <small>Ou acesse com suas credenciais</small>
                            </div>
                            <form role="form" @submit.prevent method="get">
                                <base-input alternative
                                    class="mb-3"
                                    id="modal_username"
                                    v-model="inputs.username"
                                    placeholder="Usuário ou E-mail"
                                    addon-left-icon="fa fa-user">
                                </base-input>
                                <base-input alternative
                                    type="password"
                                    placeholder="Senha"
                                    id="modal_password"
                                    v-model="inputs.password"
                                    addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <div class="text-center">
                                    <base-button nativeType="submit" @click="login($event)" type="primary" class="my-4">Acessar</base-button>
                                </div>
                            </form>
                            <div class="row mt-3">
                                <div class="col-6">
                                    <router-link to="/redefinir-senha" class="text-light">
                                        <small>Esqueceu sua Senha?</small>
                                    </router-link>
                                </div>
                                <div class="col-6 text-right">
                                    <router-link to="/registrar" class="text-light">
                                        <small>Criar uma Conta</small>
                                    </router-link>
                                </div>
                            </div>
                        </template>
                    </card>
                  </div>
                </div>
              </div>

            </div>
        </SlideYUpTransition>
    </ul>
</template>
<script>
import BaseDropdown from "@/components/BaseDropdown";
import AuthSocialComponent from "./Social/AuthSocialComponent";

import { SlideYUpTransition } from "vue2-transitions";

import { mapGetters, mapActions } from 'vuex';

import { userMixin } from "@/mixins/userMixin";

export default {
  name: "auth-modal-component",
  mixins: [userMixin],
  components: {
    BaseDropdown,
    AuthSocialComponent,
    SlideYUpTransition
  },
  data() {
    return {
      inputs: {
        username: null,
        password: null,
      },
      modal: {
        title: 'Acesso Negado!',
        body: 'Não foi possível completar a operação',
        classe: 'modal-danger',
        icon: 'fa fa-lock', 
        okButton: 'OK',
      },
    };
  },
  computed: {
    ...mapGetters('auth', [
        'isAuthenticated',
      ]),
    ...mapGetters('modal', [
        'showModal',
      ]),
    ...mapGetters('cart', [
        'sacolaTitulos',
      ]),
      userLogin: function() {
        return this.$store.state.auth.username
      }
  },
  methods: {
    ...mapActions('cart', [
        'checkCartItemToCheckout',
    ]),
  },
  beforeRouteLeave(to, from, next) {  
    this.changeModalState();
    this.inputs.username = null;
    this.inputs.password = null;
    next();
  },
};
</script>
<style scoped>
    .cart-dropdown-icon i {
        font-size: 1.3rem;
        position: relative;
        top: 5px;
        margin-right: 3px;
    }
    .cart-items .list-group-item {
        padding-left: 0;
        padding-right: 0;
    }
</style>
